/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookNotepadIcon16Light = forwardRef('BookNotepadIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.5 4a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z" }),
        React.createElement("path", { d: "M7 6.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M7.5 8a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 14h6a2.5 2.5 0 0 0 2.5-2.5v-8A2.5 2.5 0 0 0 10.5 1h-6A2.5 2.5 0 0 0 2 3.5v8A2.5 2.5 0 0 0 4.5 14Zm0-12A1.5 1.5 0 0 0 3 3.5v8A1.5 1.5 0 0 0 4.5 13H5V2h-.5ZM6 2v11h4.5a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 10.5 2H6Z" })));
});
